import { useContext } from 'react';

import { QBankStructureContext } from './qbank-structure-provider';

function useQBankStructure() {
  const context = useContext(QBankStructureContext);

  if (!context) {
    throw new Error('useQBankStructure must be used within a QBankStructureProvider');
  }

  return context;
}

export { useQBankStructure };
